import { set } from 'quartz/globalState/api';
import { applyQueryParamOverrides } from '../utils/queryParamUtils';
import { transformHublessUserInfoResponse } from 'hub-http/userInfo-internal';
import noPortalApiClient from 'hub-http/clients/noPortalApiClient';
import quickFetch from 'quick-fetch';
import hublessLoginVerifyClient from './hublessLoginVerifyClient';
import { HUBLESS_EARLY_REQUEST } from './hublessEarlyRequester';
import { getQuartzConfig } from 'quartz-config/evaluable';
import { invariant } from 'quartz/invariant';
import { HUBLESS_APP_AUTH_RESULT } from './globalState';
const quartzConfig = getQuartzConfig();
const fetchHublessUserInfo = () => {
  let resultPromise;
  const earlyMetaRequest = quickFetch.getRequestStateByName(HUBLESS_EARLY_REQUEST);
  const fetchData = () => {
    /* invariant(quartzConfig.type === 'application') */
    ;
    return /* quartzConfig.auth === 'hubless' && quartzConfig.experimental_newLogoutOnErrorBehavior === true */true ? hublessLoginVerifyClient.get('/login-verify/user-info') : noPortalApiClient.get('/login-verify/user-info');
  };
  if (earlyMetaRequest) {
    resultPromise = new Promise((resolve, reject) => {
      earlyMetaRequest.whenFinished(result => {
        resolve(result);
        quickFetch.removeEarlyRequest(HUBLESS_EARLY_REQUEST);
      });
      earlyMetaRequest.onError(() => {
        quickFetch.removeEarlyRequest(HUBLESS_EARLY_REQUEST);

        // Retry
        fetchData().then(resolve).catch(reject);
      });
    });
  } else {
    // If an early request is not made, we can just fetch the data directly.
    resultPromise = fetchData();
  }
  return resultPromise;
};
export async function initializeHublessAppAuth({
  queryParams
}) {
  const userInfoResult = await fetchHublessUserInfo().then(transformHublessUserInfoResponse);
  const gatesWithQueryParamOverrides = applyQueryParamOverrides(userInfoResult.enabledGates || [], queryParams);
  const gates = new Set(gatesWithQueryParamOverrides);
  const result = {
    // Applies query param overrides to the top-level gates array
    auth: userInfoResult,
    gates
  };
  set(HUBLESS_APP_AUTH_RESULT, result);
  return result;
}